import { createAction } from 'redux-actions';

import {STACK_CACHE_ADD} from './constants';


const stackCacheAddAction = createAction(STACK_CACHE_ADD);

export const stackCacheAddRedux = (payload) => async (dispatch) => dispatch(stackCacheAddAction(payload));

